import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';

type FolderTypologiesByBorderCrossingServiceItem = {
  descriptionTranslationKey: string;
  folderTypologyId: string;
};

type FolderTypologiesByBorderCrossingService = {
  folderTypologiesByBorderCrossingServiceListItems: FolderTypologiesByBorderCrossingServiceItem[];
};

const borderCrossingServiceId = '11A27116-A0D4-11EE-8C90-0242AC120002';

const getServicesOfferTypologiesAsync = () =>
  axios.get<FolderTypologiesByBorderCrossingService>(`/border-crossing-services/${borderCrossingServiceId}/typologies`);

export const useGetServicesOfferTypologiesAsync = () =>
  useQuery({
    queryKey: ['cutomsPass-services-offer-typologies', borderCrossingServiceId],
    queryFn: async () => {
      const { data } = await getServicesOfferTypologiesAsync();
      return new Map(
        data.folderTypologiesByBorderCrossingServiceListItems.map(({ folderTypologyId, descriptionTranslationKey }) => [
          folderTypologyId,
          descriptionTranslationKey,
        ]),
      );
    },
  });
